import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateConfigurationTerms } from '../actions'
import {
    Button,
    Card
} from '@chakra-ui/react'
import Editor from '../components/Editor'
import { getConfig } from '../reducers'

const ConfigurationTerms = () => {

    const [html, setHTML] = useState("")
    const [mounted, setMounted] = useState(false)
    const [editorSetted, setEditorSetted] = useState(false)
    const [editor, setEditor] = useState(null)
    const dispatch = useDispatch()

    const config = useSelector(state => getConfig(state))

    useEffect(() => {
        setHTML( config.terms === null ? '' : config.terms)
        setMounted(true)
    }, [])

    const saveConfigurationTerm = () => {
        const form = { terms : html}
        dispatch(updateConfigurationTerms(form))
    }

    return (
        <div>
            <legend>Contenido de Terminos y condiciones </legend>
            <br/>
            <Card>
                {mounted ?
                    <Editor placeholder={"Contenido"} setHTML={setHTML} setEditor={setEditor} initialHtml={html} setEditorSetted={setEditorSetted} editorSetted={editorSetted} />
                    : <>Loading</>
                }
            </Card>

            <Button colorScheme="teal" variant="outline" onClick={saveConfigurationTerm} mt={4}>
                Actualizar
            </Button>
        </div>
    )

}

export default ConfigurationTerms